import Particles from "@tsparticles/vue3";
import { loadSlim } from "@tsparticles/slim";
import { loadEmittersPlugin } from "@tsparticles/plugin-emitters";
import { loadEmittersShapeCircle } from "@tsparticles/plugin-emitters-shape-circle";
import type { App } from "vue";

export const initParticles = (): { install: (app: App) => void } => {
  return {
    install: (app: App): void => {
      app.use(Particles, {
        init: async (engine) => {
          await loadSlim(engine);
          await loadEmittersPlugin(engine);
          await loadEmittersShapeCircle(engine);
        },
      });
    },
  };
};
